define(["require", "exports", "jquery", "knockout", "log", "../utils/tools", "../models/GridColumnModel", "../models/UserContext"], function (require, exports, $, ko, log, tools, GridColumnModel, UserContext) {
    "use strict";
    var ExporData = /** @class */ (function () {
        function ExporData() {
            this.exportOnlySelected = ko.observable(false);
            this.allColumns = ko.observableArray();
            this.availableColumns = ko.observableArray();
            this.selectedColumns = ko.observableArray();
            this.allColumnsMaterial = ko.observableArray();
            this.allDetailColumns = ko.observableArray();
            this.availableDetailColumns = ko.observableArray();
            this.selectedDetailColumns = ko.observableArray();
            this.totalExported = ko.observable(0);
            this.hasDetails = ko.observable(false);
            this.exportDetails = ko.observable(false);
            this.detailExportPromises = [];
        }
        ExporData.prototype.openExportToExcel = function (gridId, title, entityName, kendoUtils, includeDetails) {
            if (includeDetails === void 0) { includeDetails = false; }
            var self = this;
            self.gridId = gridId;
            self.title = title;
            self.entityName = entityName;
            self.grid = $("#" + gridId).data("kendoGrid");
            self.hasDetails($("tr", self.grid.element).is(".k-master-row") || kendoUtils.hasDetailsToExport);
            self.kendoUtils = kendoUtils;
            self.exportDetails(includeDetails);
            var flattedColumns = [];
            for (var i = 0; i < self.grid.columns.length; i++) {
                var column = self.grid.columns[i];
                if (column.exportable) {
                    if (column.field && (!column.columns || column.columns.length === 0)) {
                        flattedColumns.push(column);
                    }
                    if (column.columns) {
                        for (var j = 0; j < column.columns.length; j++) {
                            var subColumn = column.columns[j];
                            if (subColumn.field) {
                                subColumn.parentTitle = column.title;
                                flattedColumns.push(subColumn);
                            }
                        }
                    }
                }
            }
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.availableColumns);
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.allColumns);
            self.totalExported(self.grid.dataSource.total());
            self.initDetailColumns();
            var selectedItemsCount = $("#" + self.gridId + " .check-row:checked").length;
            self.exportOnlySelected.subscribe(function (value) {
                if (value) {
                    self.totalExported(selectedItemsCount);
                }
                else {
                    self.totalExported(self.grid.dataSource.total());
                }
            });
            if (selectedItemsCount) {
                self.exportOnlySelected(true);
            }
            self.initExportWindow();
        };
        ExporData.prototype.openExportToExcelMaterial = function (gridId, title, entityName, kendoUtils, includeDetails) {
            if (includeDetails === void 0) { includeDetails = false; }
            var self = this;
            self.gridId = gridId;
            self.title = title;
            self.entityName = entityName;
            self.grid = $("#" + gridId).data("kendoGrid");
            self.hasDetails($("tr", self.grid.element).is(".k-master-row") || kendoUtils.hasDetailsToExport);
            self.kendoUtils = kendoUtils;
            self.exportDetails(includeDetails);
            var flattedColumns = [];
            for (var i = 0; i < self.grid.columns.length; i++) {
                var column = self.grid.columns[i];
                if (column.exportable) {
                    if (column.field && (!column.columns || column.columns.length === 0)) {
                        flattedColumns.push(column);
                    }
                    if (column.columns) {
                        for (var j = 0; j < column.columns.length; j++) {
                            var subColumn = column.columns[j];
                            if (subColumn.field) {
                                subColumn.parentTitle = column.title;
                                flattedColumns.push(subColumn);
                            }
                        }
                    }
                }
            }
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.availableColumns);
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.allColumns);
            self.totalExported(self.grid.dataSource.total());
            self.allColumnsMaterial = ko.observableArray(ko.utils.arrayMap(self.allColumns(), function (column) {
                return {
                    selected: !column.hidden(),
                    field: column.field(),
                    title: column.parentTitle && column.parentTitle() ? column.parentTitle() + ' - ' + column.title() : column.title()
                };
            }));
            self.initExportWindowMaterial();
        };
        ExporData.prototype.initExportWindowMaterial = function () {
            var self = this;
            var mainElement = document.getElementById("exportWizardDialog");
            ko.cleanNode(mainElement);
            $(mainElement).html("<div data-bind=\"template: { name: 'export-data-template', data: $root }\"></div>");
            ko.applyBindings(self, mainElement);
            $(".js-select-all", mainElement).on("click", function (event) {
                var checked = $(event.currentTarget).prop('checked');
                var selectContainer = $(event.currentTarget).closest(".panel").find(".panel-body");
                $("input[type='checkbox']", selectContainer).prop('checked', checked);
            });
            $("#exportWizardDialog").modal("show");
        };
        ExporData.prototype.exportMaterialClicked = function () {
            var self = this;
            self.selectedColumns.remove(function (item) { return true; });
            var fields = $("input:checkbox[name=selectedExportFields]:checked")
                .map(function (index, element) { return $(element).val(); }); //FIXME: .get();
            ko.utils.arrayForEach(self.allColumns(), function (item) {
                if (fields.indexOf(item.field()) > -1) {
                    self.selectedColumns.push(item);
                }
            });
            self.doExportMaterial();
        };
        ExporData.prototype.initExportWindow = function () {
            var self = this;
            self.modal = tools.editModal({
                title: "Export Data Wizard - " + self.title,
                buttonTitle: "Export",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.doExport(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'export-data-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                    function placeholder() {
                        return $("<li class='list-item' id='placeholder'>Drop Here!</li>");
                    }
                    $("#sortable-listA", modal).kendoSortable({
                        connectWith: "#" + modal.id + " #sortable-listB",
                        placeholder: placeholder,
                        cursor: "move",
                        change: function (e) {
                            $(e.item).removeClass("selected");
                        }
                    });
                    $("#sortable-listB", modal).kendoSortable({
                        connectWith: "#" + modal.id + " #sortable-listA",
                        placeholder: placeholder,
                        cursor: "move",
                        change: function (e) {
                            //log.log(oldIndex, newIndex, e);
                            var column = ko.utils.arrayFirst(self.allColumns(), function (item) {
                                return item.field() === $(e.item).data("id");
                            });
                            $(e.item).removeClass("selected");
                            if (e.action === "receive") {
                                if (column) {
                                    self.selectedColumns.splice(e.newIndex, 0, column);
                                }
                            }
                            if (e.action === "remove") {
                                if (column) {
                                    self.selectedColumns.remove(function (item) { return item.field() === column.field(); });
                                }
                            }
                            if (e.action === "sort") {
                                if (column) {
                                    self.selectedColumns.splice(e.newIndex, 0, self.selectedColumns.splice(e.oldIndex, 1)[0]);
                                }
                            }
                            var orderNames = ko.utils.arrayMap(self.selectedColumns(), function (item) { return item.fullTitle(); });
                            log.log(orderNames);
                        }
                    });
                    ko.utils.arrayForEach(self.allColumns(), function (item) {
                        if (!item.hidden() && item.field()) {
                            self.selectedColumns.push(item);
                            $('#sortable-listA [data-id="' + item.field() + '"]', modal).removeClass("selected").appendTo($("#sortable-listB", modal));
                        }
                    });
                    $("#sortable-detail-listA", modal).kendoSortable({
                        connectWith: "#" + modal.id + " #sortable-detail-listB",
                        placeholder: placeholder,
                        cursor: "move",
                        change: function (e) {
                            $(e.item).removeClass("selected");
                        }
                    });
                    $("#sortable-detail-listB", modal).kendoSortable({
                        connectWith: "#" + modal.id + " #sortable-detail-listA",
                        placeholder: placeholder,
                        cursor: "move",
                        change: function (e) {
                            //log.log(oldIndex, newIndex, e);
                            var column = ko.utils.arrayFirst(self.allDetailColumns(), function (item) {
                                return item.field() === $(e.item).data("id");
                            });
                            $(e.item).removeClass("selected");
                            if (e.action === "receive") {
                                if (column) {
                                    self.selectedDetailColumns.splice(e.newIndex, 0, column);
                                }
                            }
                            if (e.action === "remove") {
                                if (column) {
                                    self.selectedDetailColumns.remove(function (item) { return item.field() === column.field(); });
                                }
                            }
                            if (e.action === "sort") {
                                if (column) {
                                    self.selectedDetailColumns.splice(e.newIndex, 0, self.selectedColumns.splice(e.oldIndex, 1)[0]);
                                }
                            }
                        }
                    });
                    ko.utils.arrayForEach(self.allDetailColumns(), function (item) {
                        if (!item.hidden() && item.field()) {
                            self.selectedDetailColumns.push(item);
                            $('#sortable-detail-listA [data-id="' + item.field() + '"]', modal).removeClass("selected").appendTo($("#sortable-detail-listB", modal));
                        }
                    });
                    $(".list-wrapper", modal).on("click", "li", function () {
                        $(this).toggleClass("selected");
                    });
                }
            });
        };
        ExporData.prototype.initDetailColumns = function () {
            var self = this;
            if (!self.kendoUtils.detailsGridStructure) {
                return;
            }
            var flattedColumns = [];
            for (var i = 0; i < self.kendoUtils.detailsGridStructure.columns.length; i++) {
                var column = self.kendoUtils.detailsGridStructure.columns[i];
                if (column.exportable) {
                    if (column.field) {
                        flattedColumns.push(column);
                    }
                    if (column.columns) {
                        for (var j = 0; j < column.columns.length; j++) {
                            var subColumn = column.columns[j];
                            if (subColumn.field) {
                                subColumn.parentTitle = column.title;
                                flattedColumns.push(subColumn);
                            }
                        }
                    }
                }
            }
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.availableDetailColumns);
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.allDetailColumns);
        };
        ExporData.prototype.addColumns = function () {
            var self = this;
            $("#sortable-listA .list-item.selected", self.modal).each(function () {
                var _this = this;
                var column = ko.utils.arrayFirst(self.allColumns(), function (item) {
                    return item.field() === $(_this).data("id");
                });
                if (column) {
                    self.selectedColumns.push(column);
                }
            });
            $("#sortable-listA .list-item.selected", self.modal).removeClass("selected").appendTo($("#sortable-listB", self.modal));
        };
        ExporData.prototype.removeColumns = function () {
            var self = this;
            $("#sortable-listB .list-item.selected", self.modal).each(function () {
                var _this = this;
                self.selectedColumns.remove(function (item) { return item.field() === $(_this).data("id"); });
            });
            $("#sortable-listB .list-item.selected", self.modal).removeClass("selected").appendTo($("#sortable-listA", self.modal));
        };
        ExporData.prototype.addDetailColumns = function () {
            var self = this;
            $("#sortable-detail-listA .list-item.selected", self.modal).each(function () {
                var _this = this;
                var column = ko.utils.arrayFirst(self.allDetailColumns(), function (item) {
                    return item.field() === $(_this).data("id");
                });
                if (column) {
                    self.selectedDetailColumns.push(column);
                }
            });
            $("#sortable-detail-listA .list-item.selected", self.modal).removeClass("selected").appendTo($("#sortable-detail-listB", self.modal));
        };
        ExporData.prototype.removeDetailColumns = function () {
            var self = this;
            $("#sortable-detail-listB .list-item.selected", self.modal).each(function () {
                var _this = this;
                self.selectedDetailColumns.remove(function (item) { return item.field() === $(_this).data("id"); });
            });
            $("#sortable-detail-listB .list-item.selected", self.modal).removeClass("selected").appendTo($("#sortable-detail-listA", self.modal));
        };
        ExporData.prototype.getSelectedRows = function () {
            var self = this;
            var dataItems = [];
            var trs = $("#" + self.gridId).find("tr");
            for (var i = 0; i < trs.length; i++) {
                if ($(trs[i]).find(":checkbox").is(":checked")) {
                    var dataItem = self.grid.dataItem(trs[i]);
                    dataItems.push(dataItem);
                }
            }
            return dataItems;
        };
        ExporData.prototype.doExportMaterial = function () {
            var self = this;
            var masterData, rowIndex;
            $("#exportWizardDialog .js-export").text("Exporting...");
            $("#exportWizardDialog .js-export").prop("disabled", "disabled");
            var excelExportHandler = function (e) {
                e.preventDefault();
                masterData = e.data;
                self.detailExportPromises = [];
                if (self.exportDetails()) {
                    for (rowIndex = 0; rowIndex < masterData.length; rowIndex++) {
                        self.exportChildData(masterData[rowIndex], rowIndex);
                    }
                }
                $.when.apply(null, self.detailExportPromises).
                    then(function () {
                    // get the export results
                    var detailExports = $.makeArray(arguments);
                    // sort by masterRowIndex
                    detailExports.sort(function (a, b) {
                        return a.masterRowIndex - b.masterRowIndex;
                    });
                    self.createExportFile(masterData, detailExports);
                    self.grid.unbind("excelExport", excelExportHandler);
                    $("#exportWizardDialog .js-export").text("Export");
                    $("#exportWizardDialog .js-export").prop("disabled", "");
                    $("#exportWizardDialog").modal("hide");
                });
            };
            self.grid.bind("excelExport", excelExportHandler);
            self.grid.saveAsExcel();
        };
        ExporData.prototype.doExport = function (btn, modal) {
            var self = this;
            var masterData, rowIndex;
            if (self.exportOnlySelected()) {
                self.doServerSideExport(btn, modal);
                /*masterData = self.getSelectedRows();
                self.detailExportPromises = [];
    
                if (self.exportDetails()) {
                    for (rowIndex = 0; rowIndex < masterData.length; rowIndex++) {
                        self.exportChildData(masterData[rowIndex], rowIndex);
                    }
                }
    
                $.when.apply(null, self.detailExportPromises).
                    then(function () {
    
                        // get the export results
                        var detailExports = $.makeArray(arguments);
    
                        // sort by masterRowIndex
                        detailExports.sort((a, b) => {
                            return a.masterRowIndex - b.masterRowIndex;
                        });
    
                        self.createExportFile(masterData, detailExports);
    
                        $(btn).button("reset");
                    });*/
            }
            else if (self.totalExported() > -1) {
                self.doServerSideExport(btn, modal);
            }
            else {
                var excelExportHandler = function (e) {
                    e.preventDefault();
                    masterData = e.data;
                    self.detailExportPromises = [];
                    if (self.exportDetails()) {
                        for (rowIndex = 0; rowIndex < masterData.length; rowIndex++) {
                            self.exportChildData(masterData[rowIndex], rowIndex);
                        }
                    }
                    $.when.apply(null, self.detailExportPromises).
                        then(function () {
                        // get the export results
                        var detailExports = $.makeArray(arguments);
                        // sort by masterRowIndex
                        detailExports.sort(function (a, b) {
                            return a.masterRowIndex - b.masterRowIndex;
                        });
                        self.createExportFile(masterData, detailExports);
                        self.grid.unbind("excelExport", excelExportHandler);
                        $(btn).button("reset");
                    });
                };
                if (self.totalExported() > -1) {
                }
                else {
                    self.grid.bind("excelExport", excelExportHandler);
                    self.grid.saveAsExcel();
                }
                //data = self.grid.dataSource.data();
            }
        };
        ExporData.prototype.doServerSideExport = function (btn, modal) {
            var self = this;
            var url = self.grid.dataSource.options.transport.read.url;
            var data = self.grid.dataSource.options.transport.read.data();
            data['sort'] = self.grid.dataSource.sort();
            data['filter'] = self.grid.dataSource.filter();
            data['take'] = self.grid.dataSource.total();
            data['skip'] = 0;
            var masterColumnsArray = ko.utils.arrayMap(self.selectedColumns(), function (item) {
                return {
                    Field: item.field(),
                    Title: item.title(),
                    ExportFormat: item.exportFormat(),
                    Template: item.template(),
                    UseTemplateValue: item.useTemplateValue()
                };
            });
            var detailsColumnsArray = ko.utils.arrayMap(self.selectedDetailColumns(), function (item) {
                return {
                    Field: item.field(),
                    Title: item.title(),
                    ExportFormat: item.exportFormat(),
                    Template: item.template(),
                    UseTemplateValue: item.useTemplateValue()
                };
            });
            console.log(url);
            console.log(data);
            var oReq = new XMLHttpRequest();
            oReq.open("POST", "/Export/ExportGrid", true);
            oReq.responseType = "blob";
            oReq.onload = function (oEvent) {
                var arrayBuffer = oReq.response;
                var blob = arrayBuffer;
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var fileName = kendo.toString(new Date(), "MM-dd-yy_hh-mm-ss_tt");
                fileName += "-" + UserContext.currentUser().userName + "-" + self.title.replace(" ", "") + ".xlsx";
                self.logExport(fileName, null, false);
                link['download'] = fileName;
                link.click();
                $(btn).button("reset");
            };
            var formData = new FormData();
            formData.append("masterUrl", url);
            formData.append("masterData", tools.modelToJSON(data));
            formData.append("selectedColumns", btoa(tools.modelToJSON(masterColumnsArray)));
            formData.append("selectedDetailsColumns", btoa(tools.modelToJSON(detailsColumnsArray)));
            formData.append("selectedOnly", "".concat(self.exportOnlySelected()));
            formData.append("exportDetails", "".concat(self.exportDetails()));
            if (self.exportOnlySelected()) {
                var masterRecords = self.getSelectedRows();
                formData.append("masterRecords", tools.modelToJSON(masterRecords));
            }
            if (self.exportDetails()) {
                formData.append("detailsUrl", self.kendoUtils.detailsDataSource.transport.read.url);
                /*var detailsFilterMap = {};
                for (var k = 0; k < self.kendoUtils.exportFilterMap.length; k++) {
                    var dataMap = self.kendoUtils.exportFilterMap[k];
    
                    if (dataMap.masterRowField) {
                        detailsFilterMap[dataMap.filterField] = detailsFilterMap[dataMap.masterRowField];
                    }
                    if (dataMap.value) {
                        if (typeof dataMap.value === "function") {
                            detailsFilterMap[dataMap.filterField] = dataMap.value.call(self, data);
                        } else {
                            detailsFilterMap[dataMap.filterField] = dataMap.value;
                        }
                    }
                }*/
                var detailsFilterMap = self.kendoUtils.exportFilterMap;
                formData.append("detailsFilterMap", JSON.stringify(detailsFilterMap));
            }
            oReq.send(formData);
        };
        ExporData.prototype.exportChildData = function (masteRowData, rowIndex) {
            var self = this;
            var deferred = $.Deferred();
            self.detailExportPromises.push(deferred);
            self.kendoUtils.detailsDataSource.transport.read.data = function () {
                var data = {};
                for (var k = 0; k < self.kendoUtils.exportFilterMap.length; k++) {
                    var dataMap = self.kendoUtils.exportFilterMap[k];
                    if (dataMap.masterRowField) {
                        data[dataMap.filterField] = masteRowData[dataMap.masterRowField];
                    }
                    if (dataMap.value) {
                        if (typeof dataMap.value === "function") {
                            data[dataMap.filterField] = dataMap.value.call(self, masteRowData);
                        }
                        else {
                            data[dataMap.filterField] = dataMap.value;
                        }
                    }
                }
                return data;
            };
            var columns = $.map(self.selectedDetailColumns(), function (item) {
                return { field: item.field() };
            });
            var exporter = new kendo.ExcelExporter({
                columns: columns,
                allPages: true,
                dataSource: new kendo.data.DataSource(self.kendoUtils.detailsDataSource)
            });
            exporter.workbook().then(function (book, data) {
                deferred.resolve({
                    masterRowIndex: rowIndex,
                    data: data,
                    sheet: book.sheets[0]
                });
            });
        };
        ExporData.prototype.createExportFile = function (data, detailsData) {
            var self = this;
            var detailColumnsArray, detailColumns, detailHeaderCell;
            var columnsArray = ko.utils.arrayMap(self.selectedColumns(), function (item) {
                return {
                    field: item.field(),
                    exportFormat: item.exportFormat(),
                    template: item.template(),
                    useTemplateValue: item.useTemplateValue()
                };
            });
            var columns = {};
            ko.utils.arrayForEach(columnsArray, function (item) {
                columns[item.field] = item;
            });
            if (self.exportDetails()) {
                detailColumnsArray = ko.utils.arrayMap(self.selectedDetailColumns(), function (item) {
                    return {
                        field: item.field(),
                        exportFormat: item.exportFormat(),
                        template: item.template(),
                        useTemplateValue: item.useTemplateValue()
                    };
                });
                detailColumns = {};
                ko.utils.arrayForEach(detailColumnsArray, function (item) {
                    detailColumns[item.field] = item;
                });
                detailHeaderCell = ko.utils.arrayMap(self.selectedDetailColumns(), function (item) {
                    return {
                        value: item.fullTitle(),
                        background: "#DDD9C4",
                        autoWidth: true
                    };
                });
                detailHeaderCell.unshift({
                    value: "",
                    background: "#DDD9C4",
                    autoWidth: true
                });
            }
            var headerCell = ko.utils.arrayMap(self.selectedColumns(), function (item) {
                return {
                    value: item.fullTitle(),
                    background: "#DDD9C4",
                    autoWidth: true
                };
            });
            var footerCell = null;
            var aggregates = self.grid.dataSource.aggregates();
            if (aggregates) {
                log.log(aggregates);
                footerCell = ko.utils.arrayMap(self.selectedColumns(), function (item) {
                    var footerTemplate = item.footerTemplate();
                    var valueItem = aggregates[item.field()] || {};
                    var valueCell;
                    if (footerTemplate) {
                        var template = kendo.template(footerTemplate);
                        if (typeof (footerTemplate) === 'function') {
                            valueCell = template(aggregates);
                        }
                        else {
                            valueCell = template(valueItem);
                        }
                        valueCell = tools.stripHtml(valueCell);
                    }
                    else {
                        valueCell = valueItem;
                    }
                    return {
                        value: valueCell,
                        background: "#DDD9C4",
                        autoWidth: true
                    };
                });
            }
            var workbookColumns = ko.utils.arrayMap(self.selectedColumns(), function (item) {
                return {
                    autoWidth: true
                };
            });
            var rows = [{
                    cells: headerCell
                }];
            var index = 0;
            ko.utils.arrayForEach(data, function (item) {
                var cells = [];
                ko.utils.arrayForEach(columnsArray, function (field) {
                    var column = columns[field.field];
                    var valueCell = item[field.field];
                    if (column.useTemplateValue) {
                        var template = kendo.template(column.template);
                        valueCell = template(item);
                        valueCell = tools.stripHtml(valueCell);
                        cells.push({ value: valueCell, format: field.exportFormat ? field.exportFormat : null });
                    }
                    else {
                        cells.push({ value: valueCell, format: field.exportFormat ? field.exportFormat : null });
                    }
                });
                rows.push({
                    cells: cells
                });
                //add details
                if (self.exportDetails()) {
                    var detailsItem = ko.utils.arrayFirst(detailsData, function (detaiItem) {
                        return detaiItem.masterRowIndex === index;
                    });
                    if (detailsItem) {
                        //push details header
                        rows.push({
                            cells: detailHeaderCell
                        });
                        ko.utils.arrayForEach(detailsItem.data, function (dataItem) {
                            var detailCells = [];
                            ko.utils.arrayForEach(detailColumnsArray, function (field) {
                                var column = detailColumns[field.field];
                                if (column) {
                                    var valueCell = dataItem[field.field];
                                    if (column.useTemplateValue) {
                                        var template = kendo.template(column.template);
                                        valueCell = template(dataItem);
                                        valueCell = tools.stripHtml(valueCell);
                                        detailCells.push({ value: valueCell, format: field.exportFormat ? field.exportFormat : null });
                                    }
                                    else {
                                        detailCells.push({ value: valueCell, format: field.exportFormat ? field.exportFormat : null });
                                    }
                                }
                                else {
                                    detailCells.push({ value: "" });
                                }
                            });
                            rows.push({
                                cells: detailCells
                            });
                        });
                    }
                }
                index++;
            });
            if (footerCell) {
                rows.push({
                    cells: footerCell
                });
            }
            var workbook = new kendo.ooxml.Workbook({
                sheets: [
                    {
                        columns: workbookColumns,
                        // Title of the sheet
                        title: self.title,
                        // Rows of the sheet
                        rows: rows
                    }
                ]
            });
            var fileName = kendo.toString(new Date(), "MM-dd-yy_hh-mm-ss_tt"); // "2015-04-21-16-45-59-igoldstein@telego.net-PhoneNumbers.xlsx"
            fileName += "-" + UserContext.currentUser().userName + "-" + self.title.replace(" ", "") + ".xlsx";
            //save the file as Excel file with extension xlsx
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: fileName,
                proxyURL: "/Export/SaveProxy",
                forceProxy: data.length > 4000
            });
            self.logExport(fileName, workbook.toDataURL(), data.length <= 4000);
        };
        ExporData.prototype.logExport = function (fileName, fileData, logData) {
            var self = this;
            var logResult = {
                exportedSelected: self.exportOnlySelected(),
                fileName: fileName,
                exportRequestUrl: self.grid.dataSource.options.transport.read.url,
                exportRequestData: self.grid.dataSource.options.transport.read.data(),
                totalRecords: self.totalExported()
            };
            var logString = JSON.stringify(logResult);
            tools.ajaxPost({
                url: "/logs/logexport",
                data: {
                    entityName: self.entityName,
                    logJson: logString,
                    fileName: fileName,
                    fileData: logData ? fileData : "data too long"
                }
            }).done(function () {
                log.log("export log saved");
            });
        };
        return ExporData;
    }());
    return ExporData;
});
//# sourceMappingURL=exportData.js.map


//////////////////
// WEBPACK FOOTER
// ./build/shared/exportData.js
// module id = 154
// module chunks = 2